import {
  Button,
  Checkbox,
  Input,
  Popconfirm,
  Select,
  Table,
  message,
} from "antd";
import Column from "antd/es/table/Column";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import ActiveAccounts from "./activeFunction";
import ActivePersonalAccounts from "./activePersonalFunction.js";
import AddNewVisa from "./addNewVisaFunction.js";
import AddNewVisaVerifyPersonal from "./addNewVisaVerifyPersonalFunction.js";
import BackupVisaPersonalFunction from "./backupVisaPersonalFunction.js";
import CancelAccounts, { testProfile } from "./cancelFunction";
import CheckPayRequireFunction from "./checkPayRequireFunction.js";
import ComplaintAdEligible from "./complaintAdEligibleFunction.js";
import CreateAccInMCCFunction from "./createAccInMCCFunction.js";
import CreateAcctsProfilesFunction from "./createAcctsProfilesFunction.js";
import CreateAdAccFullFunction from "./createAdAccFullFunction.js";
import CreateAdAcctOffer from "./createAdAcctOfferFunction.js";
import FinishAcctsFunction from './finishAcctsFunction.js';
import LinkAccounts from "./linkAccountsFunction.js";
import LoadMccFunction from "./loadMccFunction.js";
import LoginProfilesFunction from './loginProfilesFunction.js';
import RemoveVisaPersonalFunction from "./removeVisaPersonalFunction.js";
import ResetVerifications from "./resetVerificationsFunction.js";
import UpCampaignFunction from "./upCampaignFunction.js";
import UpCamProfilesFunction from "./upCamProfilesFunction.js";
import CreateAdAccount from "./createAdAccFunction.js";
import CreateAdAccountSingle from "./createAdAccSingleFunction.js";
import ComplaintSuspend_v4 from "./complainFunction_v4.js";

function Gpm() {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState(process.env.NODE_ENV === 'development' ? [testProfile] : []);
  const [groups, setGroups] = useState([]);
  const [selectGroup, setSelectGroup] = useState();
  const [selectGroupName, setSelectGroupName] = useState();
  const [selected, setSelected] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [filters, setFilters] = useState([]);
  const [quantityMultiple, setQuantity] = useState(20);
  const [nation, setNation] = useState('USA');
  const [concurrency, setConcurrency] = useState(2);
  const [numberOfAcc, setNumberOfAcc] = useState(1);
  const [numberOfPersonAcc, setNumberOfPersonAcc] = useState(9);
  const [typeSaving, setTypeSaving] = useState(false);
  const [needVerify, setNeedVerify] = useState(true);
  const [needDisable, setNeedDisable] = useState(false);
  const [useExistBank, setUseExistBank] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_HOST}/api/groups`)
      .then((groups) => {
        setLoading(false);
        let groupsOptions = groups.data.data.map((g) => {
          return { label: g.name, value: g.id };
        });
        setGroups(groupsOptions);
      })
      .catch((e) => { setLoading(false); });
    return () => {
      setDataSource([]);
    };
  }, []);

  const syncFolderXM = () => {
    let userName = localStorage.getItem('ga-userName');
    axios.post(`${API_HOST}/api/sync/folder`, { userName })
  }

  useEffect(() => {
    let filters = dataSource.map((p) => {
      return { text: p.name, value: p.name };
    });
    setFilters(filters);
  }, [dataSource]);

  useEffect(() => {
    setLoading(true);
    if (groups && groups.length > 0 && selectGroup) {
      const selectGroupName = groups.filter(g => g.value === selectGroup)[0].label;
      setSelectGroupName(selectGroupName);
      if (selectGroupName.toLowerCase().includes('all')) {
        return;
      }
      axios
        .get(`${API_HOST}/api/profiles?group_id=${selectGroup}`)
        .then((profiles) => {
          setLoading(false);
          setDataSource(mappingDatasource(profiles.data.data) || [testProfile]);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }, [selectGroup]);

  const mappingDatasource = (arrays) => {
    return arrays.map((a) => {
      return { ...a, key: a.id };
    });
  };
  const openProfile = async (profile) => {
    await axios.get(`${API_HOST}/api/profiles/open/${profile.id}`);
  }
  const closeProfile = async (profile) => {
    await axios.get(`${API_HOST}/api/profiles/close/${profile.id}`);
  }

  const addBankMultiple = () => {
    messageApi.info(`>>> Đang chạy Add Bank: ${selected.length} profile ...`);
    let body = {
      profiles: selected,
      newAdvertising: true,
      needVerify: needVerify,
      concurrency: concurrency,
      numberOfAcc: numberOfAcc,
      numberOfPersonAcc: numberOfPersonAcc,
      typeSaving: typeSaving,
      useExistBank: useExistBank,
      needDisable: needDisable
    };
    axios
      .post(`${API_HOST}/api/addBank/multiple`, body)
      .then((res) => messageApi.success(`Đang chạy ...`))
      .catch((e) => {
        console.log("🚀 ~ addBank ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  const createPersonalMultiple = () => {
    let body = {
      profiles: selected,
      concurrency: concurrency,
      quantity: Number(quantityMultiple),
      country: nation
    };
    axios
      .post(`${API_HOST}/api/account/personal/multiple`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Tạo TK CN ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  const complaintMultiple = async () => {
    let body = {
      profiles: selected,
      concurrency: concurrency
    };
    axios
      .post(`${API_HOST}/api/account/complaint/multiple`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ complaint ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const createMCCMultiple = async () => {
    let body = {
      profiles: selected,
      concurrency: concurrency,
      nation: nation
    };
    axios
      .post(`${API_HOST}/api/account/mcc/multiple`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Tạo MCC ~ e:", e);
        messageApi.error(e.response.data);
      });

  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log("🚀 ~ Gpm ~ rowSelection.selectedRows:", selectedRows);
      setSelected(selectedRows);
    },
    getCheckboxProps: (record) => record,
  };
  const onFilter = (value, record) => {
    return record.name.includes(value);
  };
  const onChange = (pagination, filters, sorter, extra) => { };

  return (
    <div>
      {contextHolder}
      <div className="btn-profiles">
        {selected.length > 0 && (
          <div className="fixed-buttons">
            <label>Chạy cùng lúc: </label>
            <Input
              placeholder="Chạy cùng lúc ? profile"
              value={concurrency}
              onChange={(e) => setConcurrency(Number(e.target.value))}
              style={{ width: 80 }}
            />
            <Popconfirm
              style={{ minWidth: 500 }}
              placement="left"
              okText="OK"
              cancelText="Hủy"
              title="Chạy: CHF Kháng Né"
              description={<></>}
              onConfirm={() => complaintMultiple()}
            >
              <Button danger>CHF Kháng: {selected.length}</Button>
            </Popconfirm>
            <Popconfirm
              style={{ minWidth: 500 }}
              placement="left"
              okText="OK"
              cancelText="Hủy"
              title="Tạo MCC & DK Partner"
              onConfirm={() => createMCCMultiple()}
              description={
                <>
                  <label>Loại TK: </label>
                  <Select
                    defaultValue={nation}
                    onChange={(value) => setNation(value)}
                    options={[
                      { value: "USA", label: "USA" },
                      { value: "CHF", label: "CHF" },
                    ]}
                  />
                </>
              }
            >
              <Button type="primary">
                Tạo MCC & Parter: {selected.length}
              </Button>
            </Popconfirm>
            <Popconfirm
              style={{ minWidth: 500 }}
              placement="left"
              okText="OK"
              cancelText="Hủy"
              title="Chạy Tạo TK CN:"
              description={
                <>
                  <label>Loại TK: </label>
                  <Select
                    defaultValue={nation}
                    onChange={(value) => setNation(value)}
                    options={[
                      { value: "USA", label: "USA" },
                      { value: "CHF", label: "CHF" },
                      { value: "ILS", label: "ILS" },
                    ]}
                  />
                  <br />
                  <label>Lượng TK tạo: </label>
                  <Input
                    placeholder="Lượng TK Tạo"
                    value={quantityMultiple}
                    onChange={(e) => setQuantity(Number(e.target.value))}
                    style={{ width: 100 }}
                  />
                  <br />
                </>
              }
              onConfirm={createPersonalMultiple}
            >
              <Button type="primary">Tạo TK CN: {selected.length}</Button>
            </Popconfirm>

            <Popconfirm
              style={{ minWidth: 500 }}
              placement="left"
              okText="OK"
              cancelText="Hủy"
              title="Chạy Add bank nhiều TK:"
              description={
                <>
                  <Checkbox defaultChecked={true} >
                    Auto Chọn Bank mới + nhà QC duy nhất/ngày
                  </Checkbox>
                  <br />
                  <Checkbox checked={needVerify} onChange={e => setNeedVerify(e.target.checked)}>
                    Xác Thực nhà QC
                  </Checkbox>
                  <br />
                  <Checkbox checked={needDisable} onChange={e => setNeedDisable(e.target.checked)}>
                    Hủy TK sau Add Bank
                  </Checkbox>
                  <br />
                  <Checkbox checked={typeSaving} onChange={e => setTypeSaving(e.target.checked)}>
                    Loại: Saving
                  </Checkbox>
                  <br />
                  <Checkbox checked={useExistBank} onChange={e => setUseExistBank(e.target.checked)}>
                    Sử dụng Bank cũ Nếu Có
                  </Checkbox>
                  <br />
                  <label>Số lượng: </label>
                  <br />
                  <label>TK con: &nbsp;</label>
                  <Input placeholder="Số TK con cần add" value={numberOfAcc} type="number"
                    status={numberOfAcc < 0 ? 'error' : 'success'}
                    onChange={(e) => setNumberOfAcc(e.target.value)} style={{ width: 100 }} />
                  <br />
                  <label>TK CN: &nbsp;&nbsp;</label>
                  <Input placeholder="Số TK CN cần add" value={numberOfPersonAcc} type="number"
                    status={numberOfPersonAcc < 0 ? 'error' : 'success'}
                    onChange={(e) => setNumberOfPersonAcc(e.target.value)} style={{ width: 100 }} />
                  <br />

                </>
              }
              onConfirm={addBankMultiple}
            >
              <Button type="primary">Add Bank {selected.length}</Button>
            </Popconfirm>
          </div>
        )}
      </div>
      <div className="white flex-between border">
        {!selectGroup && <p style={{ color: 'red' }}>[Chọn DS] </p>}
        <div>
          <label>Danh Sách: </label>
          <Select
            showSearch
            filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())}
            onChange={(value) => {
              setSelectGroup(value);
            }}
            options={groups}
            style={{ width: 300 }}
          />
        </div>
        <LoginProfilesFunction />
        <CreateAcctsProfilesFunction />
        <FinishAcctsFunction />
        <CheckPayRequireFunction />
        <ResetVerifications />
        <UpCamProfilesFunction />
        &nbsp;
        {/* <SelectRemoteServer 
          showAction
          onSelected={(server) => {}}
        /> */}
        &nbsp;
        {/* <Button size="small" onClick={(e) => {
            messageApi.info(`Đang Đồng Bộ XM ...`);
            syncFolderXM()
          }}>
          <SyncOutlined />Đồng Bộ Folder XM
        </Button> */}
      </div>
      <Table
        loading={loading}
        onChange={onChange}
        dataSource={dataSource}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        pagination={false}
      >
        <Column
          title="ID"
          key="Id"
          render={(_, record) => (
            <label>
              {record.id}
            </label>
          )}
        />
        <Column
          title="Name"
          key="name"
          filters={filters}
          filterSearch={true}
          filterMode="menu"
          onFilter={onFilter}
          render={(_, record) => (
            <label>
              {record.name}
              <br />
              <div className="flex-space" style={{ marginBottom: 10 }}>
                <Button onClick={() => openProfile(record)} type="primary">Mở</Button>
                <Button onClick={() => closeProfile(record)} danger>Đóng</Button>
              </div>
              <LoadMccFunction profile={record} />
            </label>
          )}
        />
        <Column title="Note" dataIndex="note" key="note" />
        {/* <Column title="Thống Kê" key="stat" 
            render={(_, record) => (
              <Stat profile={record} groupName={selectGroupName}/>
            )}
        /> */}
        <Column
          title="Action"
          key="action"
          align="center"
          render={(_, record) => (
            <>
              <div className="flex-end">
                <div className="flex-end" style={{ padding: '4px', border: 'solid 1px green', borderRadius: '4px' }}>
                  <CreateAccInMCCFunction profile={record} />
                  <AddNewVisa profile={record} site="MCC" />
                  {/* <AddNewVisa profile={record} site="Local" /> */}
                </div>
                <ActiveAccounts profile={record} />
                <CancelAccounts profile={record} />
                <ComplaintSuspend_v4 profile={record} />
                <ComplaintAdEligible profile={record} />
                <UpCampaignFunction profile={record} />
                <LinkAccounts profile={record} />
              </div>
              <br />
              <div className="flex-end">
                {
                  /**
                  * <div className="flex-end" style={{ padding: '4px', border: 'solid 1px green', borderRadius: '4px' }}>
                      <AddBank profile={record} />
                      <AddVisaById profile={record} />
                      <AddNewVisaPersonal profile={record} />
                    </div>
                   */
                }
                <CreateAdAccFullFunction profile={record} />
                <CreateAdAcctOffer profile={record} />
                <div className="flex-end" style={{ padding: '4px', border: 'solid 1px blue', borderRadius: '4px' }}>
                  <CreateAdAccount profile={record} />
                  {/** <CreateAdAccountSingle profile={record} />*/}
                </div>
                <RemoveVisaPersonalFunction profile={record} />
                <BackupVisaPersonalFunction profile={record} />
                {/* <CreateMCCAndParter profile={record} /> */}
                {/* <CreatePersonalAcc profile={record} /> */}
                {/* <CreateMCCBusiness profile={record} /> */}
                <ActivePersonalAccounts profile={record} />
                {/* <CancelPaymentDue profile={record}/> */}
                <AddNewVisaVerifyPersonal profile={record} />

              </div>
            </>
          )}
        />
      </Table>
    </div>
  );
}

export default Gpm;
